import { DEFAULT_MODE, makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../utils/style';
import { CIRCLE_MARGIN_RIGHT, CIRCLE_SIZE } from '../step/pairingStep.style';
import { makeStepsTemplate } from '../pairing.utils';
import { Button } from '../../button/button.component';
import { middle } from '../../utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const STEPS_GAP = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const getInitialStyle = ({ screenSize = FULL_HD, colorMode = DEFAULT_MODE } = defaultContext) => {
  const titleFont = getFont(FONT.PARIS_2, screenSize);
  const codeFont = getFont(FONT.TOKYO_4, screenSize);

  return {
    flex: {
      direction: 'column',
    },
    Title: {
      text: {
        ...titleFont,
        textColor: colors.text[colorMode],
        maxLines: 2,
        maxLinesSuffix: '...',
        verticalAlign: 'middle',
      },
      flexItem: {
        marginBottom: 24,
      },
    },
    ...makeStepsTemplate(5, {
      flexItem: {
        marginBottom: STEPS_GAP[screenSize],
      },
    }),
    Code: {
      x: CIRCLE_SIZE[screenSize] + CIRCLE_MARGIN_RIGHT[screenSize],
      text: {
        ...codeFont,
      },
    },
    Button: {
      flexItem: {
        marginTop: STEPS_GAP[screenSize],
      },
      visible: false,
      type: Button,
      label: '',
      mountX: 0.5,
      x: middle,
    },
  };
};
